import React, { useContext } from 'react';
import Button from '@src/components/wysiwyg_editor/toolbox/Button';

import layoutImage from '@images/wysiwyg_editor/toolbox_icons/layout.svg';
import { WysiwygEditorDispatchContext } from '@src/contexts/wysiwyg/editor';

type TProps = {
  active: boolean;
};

function Layout(props: TProps) {
  const { toggleToolboxTab } = useContext(WysiwygEditorDispatchContext);

  return (
    <Button
      active={props.active}
      image={layoutImage as string}
      onClick={() => toggleToolboxTab('layout')}
    >
      Layout
    </Button>
  );
}

export default Layout;
